
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'aipb-loading-progress',
  styleUrls: ['./loading-progress.component.scss'],
  template: ` @if (loading) {<mat-progress-bar [color]="color" mode="indeterminate"></mat-progress-bar>} `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatProgressBarModule]
})
export class LoadingProgressComponent {
  @Input() loading = false;
  @Input() color: ThemePalette = 'primary';
}
